var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMina0)",
    fillRule: "evenodd",
    d: "M12 17.998c.773.031 1.007-.665 1.197-1.29c.046-.151.09-.296.14-.423c.864-.262 1.434-1.013 1.58-2.156l.963-6.845c.358-.058.979.047 1.263.125v10.162h1.714V9.425c0-1.136-.36-2-1.286-2.334v-.477c0-.624-.531-1.043-1.088-1.043c-.558 0-.992.35-1.083.986l-.069.405c-1.01.287-1.533 1.203-1.704 2.53l-.781 6.447a4 4 0 0 1-.846.07a4 4 0 0 1-.846-.07l-.781-6.447c-.172-1.327-.724-2.235-1.735-2.523l-.039-.412c-.09-.636-.525-.986-1.082-.986s-1.089.419-1.089 1.043v.48c-.925.335-1.285 1.199-1.285 2.334v8.143h1.714V7.448c.404-.134.84-.192 1.262-.124l.963 6.806c.147 1.142.717 1.893 1.581 2.155c.05.127.093.272.14.423c.19.626.424 1.32 1.197 1.29m0-1.501a4.3 4.3 0 0 1-.765-.057c.064.498.18 1.063.765 1.137c.585-.075.7-.639.765-1.137q-.381.061-.765.057m-5.572.645h-.857V9.428c0-.963.395-1.495.857-1.782zm2.21-9.721c.677.247 1.071.86 1.217 2.007l.744 6.312c-.738-.535-.853-.67-.977-1.646zm-1.781-.452v-.352c0-.45.365-.618.66-.618c.217 0 .534.112.602.589l.024.269c-.429-.056-.869.01-1.286.112M17.57 17.143h.857V9.428c0-.963-.395-1.54-.857-1.827zM15.33 7.41c-.676.248-1.041.872-1.187 2.018L13.4 15.74c.738-.536.852-.671.977-1.646zm1.812-.47v-.323c0-.45-.366-.618-.66-.618c-.218 0-.535.112-.603.589l-.054.272c.44-.053.886-.026 1.317.08",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMina0",
    x1: 12.637,
    x2: 12.352,
    y1: 5.355,
    y2: 16.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2E0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#E37B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#CE5937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E7DF2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMina);
export default __webpack_public_path__ + "static/media/mina.8dd35d37fa583cec49695ce799e90e7c.svg";
export { ForwardRef as ReactComponent };